import directives from './module';
import {AuthenticationSvc} from '../services/AuthenticationSvc';
import getCommonLinks from '../routes/commonLinks';

class Header implements ng.IComponentController {
    readonly links = getCommonLinks('ANY');

    constructor(public AuthenticationSvc: AuthenticationSvc) {
    }
}

directives.component('anmHeader', {
    controller: Header,
    templateUrl: require('header.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/anmHeader.ts